import React from "react";
import chocolateFacialImg from "./../../../../Images/FacialPage/Chocolate Mint Facial.png";

const ChocolateFacialImg = () => {
  return (
    <div className="facialExtImg">
      <img src={chocolateFacialImg} alt="chocolateFacialImg" />
    </div>
  );
};

export default ChocolateFacialImg;
